import { makeStyles } from '@material-ui/core/styles'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Theme from 'core/themes/model'
import Text from 'core/elements/Text'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  header: {
    display: 'grid',
    gridGap: theme.spacing(2),
    gridTemplateColumns: '32px 5fr',
    alignItems: 'center',
  },
  headerIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.components.table.border}`,
    borderRadius: '50%',
    width: 32,
    height: 32,
  },
}))

interface Props {
  icon: string | React.ReactNode | JSX.Element
  text: string | React.ReactNode
}

const ModalInfo = ({ icon, text }: Props) => {
  const classes = useStyles()
  return (
    <div className={classes.header}>
      <div className={classes.headerIcon}>
        <FontAwesomeIcon>{icon}</FontAwesomeIcon>
      </div>
      <Text variant="body2">{text}</Text>
    </div>
  )
}

export default ModalInfo
